// Centralized data-testid registry
export const NAV = {
  root: 'site-nav',
  logo: 'nav-logo',
  link: (name) => `nav-link-${name}`,
  cta: 'nav-cta-book-call',
  mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
  root: 'hero-section',
  headline: 'hero-headline',
  subhead: 'hero-subhead',
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
};

export const SECTION = {
  mission: 'section-mission',
  services: 'section-services',
  whyUs: 'section-why-us',
  industries: 'section-industries',
  global: 'section-global',
  founder: 'section-founder',
  testimonials: 'section-testimonials',
  ctaBand: 'section-cta-band',
};

export const SERVICE_CARD = (slug) => `service-card-${slug}`;

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-input-name',
  email: 'contact-input-email',
  company: 'contact-input-company',
  phone: 'contact-input-phone',
  service: 'contact-select-service',
  message: 'contact-input-message',
  submit: 'contact-submit-btn',
  success: 'contact-success-msg',
};

export const FOOTER = { root: 'site-footer', linkedin: 'footer-linkedin', email: 'footer-email' };
